import { Button, Modal } from "react-bootstrap";
import CustomLabel from "../shared/label/custom-label.component";
import { errorRed, neturalBlack, primaryOrange } from "../../utils/colors";

const InvalidAddress = (props) => {
  const {
    title,
    bodyMessage,
    onRemoveClick,
    displayIcon,
    buttonTitle,
    buttonType = "normal",
  } = props;
  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="login-modal-style"
        centered
      >
        <Modal.Header
          closeButton
          style={{
            borderBottom: "none",
            padding: "1.5rem 2rem",
            paddingBottom: 0,
            backgroundColor: "white",
            borderRadius: "24px",
          }}
        />
        <Modal.Body
          style={{
            padding: "0px 2rem 0px",
            marginBottom: "24px",
            marginTop: "24px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <CustomLabel
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: neturalBlack,
              }}
            >
              {title}
            </CustomLabel>
            <CustomLabel
              style={{
                fontSize: "18px",
                fontWeight: "normal",
                color: neturalBlack,
              }}
            >
              {bodyMessage}
            </CustomLabel>
          </div>
          <Button
            onClick={onRemoveClick}
            style={{
              backgroundColor:
                buttonType === "normal" ? primaryOrange : errorRed,
              borderColor: buttonType === "normal" ? primaryOrange : errorRed,
              borderRadius: "12px",
              padding: "0.75rem 2rem",
              fontSize: "16px",
              fontWeight: "bold",
              width: "100%",
              marginTop: "24px",
            }}
          >
            {buttonTitle}
            {displayIcon ? (
              <span role="img" aria-label="sad face">
                🥺
              </span>
            ) : null}
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default InvalidAddress;
